export default "__VITE_ASSET__HtOymDL6__"